import React from 'react'
import { Title } from '../shared/text-styled'
import { TextSubtitle } from './styled'

const Intro = ({ data }) => {
  const {
    wordpressWpGatsbyPage: {
      title,
      acf: { subtitle },
    },
  } = data

  return (
    <>
      <Title>{title}</Title>
      <TextSubtitle>{subtitle}</TextSubtitle>
    </>
  )
}

export default Intro
